import { render, staticRenderFns } from "./VueFormulatePage.vue?vue&type=template&id=41afda36&"
import script from "./VueFormulatePage.vue?vue&type=script&lang=js&"
export * from "./VueFormulatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports